import { querySmartContract } from "./RpcHelper";

export function formatAddress(address: string) {
    return address.substring(0, 8) + '...' + address.substring(address.length - 4)
}

export const formatNumber = (num: number): string => {
    if (num >= 1_000_000_000_000) {
        return (num / 1_000_000_000_000).toFixed(1).replace(/\.0$/, '') + 'T';
    }
    if (num >= 1_000_000_000) {
        return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    }
    if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1_000) {
        return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return currency(num);
};

export const currency = (value: number) => {
    return new Intl.NumberFormat("us", {
        maximumFractionDigits: 6
    }).format(value)
}

export const formatDenom = (denom: string): string => {
    if (!denom) {
        return "";
    }

    if (denom[0] === "u") {
        const f = denom.slice(1);

        if (f.length > 3) {
            return f === "luna" ? "Lunc" : f.toUpperCase();
        }

        return f.slice(0, 2).toUpperCase() + `TC`;
    }

    return denom;
};

export const getSymbol = async (assetInfo: { token: { contract_addr: string } } | { native_token: { denom: string } }) => {
    if ("native_token" in assetInfo) return formatDenom(assetInfo.native_token.denom)
    else if ("token" in assetInfo) {
        const { symbol } = await querySmartContract(assetInfo.token.contract_addr!, { token_info: {} })
        return symbol;
    }
    return undefined;
}

export function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export const closeApp = () => {
    const tg = (window as any).Telegram;
    if (tg.WebApp.initData) {
        tg.WebApp.close()
    } else {
        if (isMobileDevice()) {
            window.location.href = 'tg://resolve?domain=terraclassictoken_bot'
        }
    }
}